import React from 'react';
import Script from 'react-load-script';
import edapWrapper from '@homeaway/edap-wrapper';
import 'whatwg-fetch';
import './GoogleOneTap.less';
import PropTypes from 'prop-types';

class GoogleOneTapComponent extends React.Component {

    static propTypes = {
        closeOnFocusOut: PropTypes.bool,
        displayIFrame: PropTypes.bool,
        focus: PropTypes.bool,
        onCredentialsAvailable: PropTypes.func,
        loginSuccessCallback: PropTypes.func
    };

    static defaultProps = {
        closeOnFocusOut: false,
        displayIFrame: true,
        focus: false,
        onCredentialsAvailable: () => {
        },
        loginSuccessCallback: () => {
        }
    };

    constructor(props) {
        super(props);

        let windowsLocation = '';
        if (typeof window !== 'undefined') { // Window doesn't exist server side so this is needed or app will fail
            windowsLocation = window.location.href;
        }

        this.state = {
            closeKey: 'oneTapClose',
            loadScript: false,
            testName: this.props.testName,
            serviceUrl: this.props.serviceUrl || windowsLocation,
            testVariant: this.props.testVariant,
            renderedEventTriggered: false
        };

        this.checkForGoogleOneTapRender = this.checkForGoogleOneTapRender.bind(this);
        this.doGoogleYolo = this.doGoogleYolo.bind(this);
        this.getDomElement = this.getDomElement.bind(this);
        this.googleAuth = this.googleAuth.bind(this);
        this.handleFrameFocusedOut = this.handleFrameFocusedOut.bind(this);
        this.handleFrameLoad = this.handleFrameLoad.bind(this);
        this.handleScriptError = this.handleScriptError.bind(this);
        this.handleScriptLoad = this.handleScriptLoad.bind(this);
        this._closeModal = this._closeModal.bind(this);
        this._displayModal = this._displayModal.bind(this);
        this.setCloseKeyToLocalStorage = this.setCloseKeyToLocalStorage.bind(this);
        this.setFrameVisible = this.setFrameVisible.bind(this);
        this.shouldDisplayModal = this.shouldDisplayModal.bind(this);
        this.triggerTestExposure = this.triggerTestExposure.bind(this);
        this.userIsLoggedIn = this.userIsLoggedIn.bind(this);
    }

    componentDidMount() {
        if (!this.shouldDisplayModal()) {
            return;
        }

        this.triggerTestExposure();

        this.userIsLoggedIn().then((response) => {
            response.json().then((json) => {
                edapWrapper().push({
                    name: 'generic.event',
                    data: {
                        eventaction: 'googleonetap.alreadyLoggedIn',
                        eventcategory: 'googleonetap',
                        publicuuid: json.publicUuid
                    }
                });
                this.props.loginSuccessCallback(json);
            });
        }).catch(() => {
            this.setState({loadScript: true});
            window.onGoogleYoloLoad = this.doGoogleYolo;
            this.checkForGoogleOneTapRender();
        });
    }

    checkForGoogleOneTapRender() {
        const gotElement = this.getDomElement();
        if (gotElement === null) {
            setTimeout(this.checkForGoogleOneTapRender, 500);
        } else {
            gotElement.addEventListener('load', (event) => {
                setTimeout(this.handleFrameLoad, 1500, event.target);
            });
            gotElement.addEventListener('focusout', () => {
                this.handleFrameFocusedOut();
            });
        }
    }

    doGoogleYolo(googleyolo) {
        // TODO - pull all of this out and pass in as a param to the constructor if the test is successful
        googleyolo.setTimeouts(10000);
        googleyolo.hint({
            supportedAuthMethods: [
                'googleyolo://id-and-password',
                'https://accounts.google.com'
            ],
            supportedIdTokenProviders: [{
                uri: 'https://accounts.google.com',
                clientId: '42464624060-9dvu968n052patjorlqk96iq0ucbmrjs.apps.googleusercontent.com'
            }]
        }).then((credential) => {
            edapWrapper().push({
                name: 'generic.event',
                data: {
                    eventaction: 'googleonetap.clicked',
                    eventcategory: 'googleonetap'
                }
            });

            this.googleAuth(credential);
        }, (error) => {
            // TODO - do we need to check for the noCredentialsAvailable error and not log it?
            if (error.type === 'userCanceled') {
                this.setCloseKeyToLocalStorage();
            }
            edapWrapper().push({
                name: 'generic.event',
                data: {
                    eventaction: 'googleonetap.error',
                    eventcategory: 'googleonetap',
                    eventlabel: error.type
                }
            });
        });
    }

    getDomElement() {
        if (typeof window !== 'undefined') {
            return window.document.querySelector('iframe[src*=\'https://smartlock.google.com/\']');
        }
        return null;
    }

    googleAuth(credential) {
        const payload = {
            createTicketGrantingTicket: true,
            emailAddress: credential.id,
            oAuthToken: credential.idToken,
            oAuthType: 'GOOGLE',
            service: this.state.serviceUrl, // auth wasn't happy without a service URL
            tmDeviceIdKey: '00000000-0000-0000-0000-000000000000'
        };

        fetch('/auth/v2/authenticate', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify(payload)
        }).then((response) => {
            response.json().then((json) => {
                edapWrapper().push({
                    name: 'generic.event',
                    data: {
                        eventaction: 'googleonetap.authenticated',
                        eventcategory: 'googleonetap',
                        publicuuid: json.publicUuid
                    }
                });
                this.props.loginSuccessCallback(json);
            });
        }).catch((jqXHR) => {
            edapWrapper().push({
                name: 'generic.event',
                data: {
                    eventaction: 'googleonetap.error',
                    eventcategory: 'googleonetap',
                    eventlabel: 'authenticationFailed',
                    eventmessage: `${jqXHR.status}:${jqXHR.statusText}`
                }
            });
        });
    }

    handleFrameFocusedOut() {
        if (this.props.closeOnFocusOut) {
            this.setFrameVisible(false);
        }
    }

    handleFrameLoad(frame) {
        if (frame && !frame.hidden && this.shouldDisplayModal()) {
            this.props.onCredentialsAvailable();
        }
        if (this.props.displayIFrame) {
            this.setFrameVisible(true);
        }
    }

    handleScriptError() {
        edapWrapper().push({
            name: 'generic.event',
            data: {
                eventaction: 'googleonetap.error',
                eventcategory: 'googleonetap',
                eventlabel: 'scriptLoadFailed'
            }
        });
    }

    handleScriptLoad() {
        edapWrapper().push({
            name: 'generic.event',
            data: {
                eventaction: 'googleonetap.initiated',
                eventcategory: 'googleonetap'
            }
        });
    }

    setCloseKeyToLocalStorage() {
        if (localStorage) {
            localStorage.setItem(this.state.closeKey, new Date().toString());
        }
    }

    setFrameVisible(visible) {
        const frame = this.getDomElement();
        if (frame === null || frame.hidden || !this.shouldDisplayModal()) {
            return;
        }
        if (visible) {
            this._displayModal(frame);
        } else {
            this._closeModal(frame);
        }
    }

    _displayModal(frame) {
        if (frame.classList.contains('DisplayIFrame')) {// already visible
            return;
        }
        if (!this.state.renderedEventTriggered) {// trigger expose event
            this.setState({renderedEventTriggered: true});
            edapWrapper().push({
                name: 'generic.event',
                data: {
                    eventaction: 'googleonetap.exposed',
                    eventcategory: 'googleonetap'
                }
            });
        }
        frame.classList.add('DisplayIFrame');
        if (this.props.focus) {
            setTimeout(function() {
                frame.focus();
            }, 300);//wait a little for visibility transition
        }
    }

    _closeModal(frame) {
        if (!frame.classList.contains('DisplayIFrame')) {// already hidden
            return;
        }
        frame.classList.remove('DisplayIFrame');
        this.setCloseKeyToLocalStorage();
    }

    shouldDisplayModal() {
        if (localStorage) {
            let keyValue = localStorage.getItem(this.state.closeKey);
            let currentDate = new Date();
            let initialDate = new Date(keyValue);
            let diffHours = Math.abs(currentDate.getTime() - initialDate.getTime()) / 36e5;

            return diffHours >= 8;
        }
        return true;
    }

    triggerTestExposure() {
        if (typeof this.state.testName !== 'undefined' && typeof this.state.testVariant !== 'undefined') {
            if (this.state.testVariant.value !== -1) {
                edapWrapper().push({
                    name: 'test.exposure',
                    data: {
                        testname: this.state.testName,
                        variant: String(this.state.testVariant)
                    }
                });
            }
        }
    }

    userIsLoggedIn() {
        return new Promise((resolve, reject) => {
            fetch('/auth/v2/recreateSession', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    'tmDeviceIdKey': '00000000-0000-0000-0000-000000000000'
                })
            }).then((response) => {
                if (response.status >= 200 && response.status < 400) {
                    return resolve(response);
                }
                return reject();
            }).catch((e) => {
                return reject(e);
            });
        });
    }

    render() {
        const {silentMode, displayIFrame} = this.props;
        if (silentMode) {
            return null;
        }
        this.setFrameVisible(displayIFrame);
        let script = null;
        if (this.state.loadScript) {
            script = (
                <div>
                    <Script
                        url="https://smartlock.google.com/client"
                        onError={this.handleScriptError}
                        onLoad={this.handleScriptLoad}
                    />
                </div>
            );
        }
        return script;
    }

}

export default GoogleOneTapComponent;
